import React, { useState } from 'react';
import {
  Modal, ModalBody, Col, Row
} from 'reactstrap';
import AddSocialWallTabs from './AddSocialWallTabs';

const AddSocialWallImageModal = ({
    isSocialWallOpen,
    toggleSocialWall,
    setSocialWall,
    setSocialWallModal,
    socialWallImage,
    program
}) => {
    const [activeTab, setActiveTab] = useState("2");

    return (
        <Modal
            className={`modal-program-events-icons modal-lg ltr-support`}
            isOpen={isSocialWallOpen}
            toggle={toggleSocialWall}
        >
            <ModalBody className="modal-lg">
                <Col md={12} lg={12}>
                    <Row className="w100">
                        <Col md="6" lg="6" xl="6">
                            <h3>Insert Social Wall Image</h3>
                        </Col>
                    </Row>
                    <div className="pt-5 tabs">
                        <AddSocialWallTabs
                            onSelectIconOK={setSocialWall}
                            activeTab={activeTab}
                            onCancel={() => setSocialWallModal(false)}
                            icon={socialWallImage}
                            program={program}
                        />
                    </div>
                </Col>
            </ModalBody>
        </Modal>
    );
};

export default AddSocialWallImageModal;